import styled from "styled-components";

export const InstagramWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;

`;

export const PostsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;
  width: 100%;
  
   @media (min-width: 1336px) {
    grid-template-columns: 1fr 1fr 1fr;
    padding-left: 15%;
    padding-right: 15%;

  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  a {
      width: 200px;
  }
`;

